import Modal from "../../../_components/Modal"
import { searchProducts } from "../../../api/products"
import AutoComplete from "../Financial/AutoComplete"
import Text from "../../../_components/Text"
import LoadingInput from "../../../_components/LoadingInput"
import Button from "../../../_components/Button"

import React from "react"
export default (props) => {
    const [loading, setLoading] = React.useState(false);
    const [product, setProduct] = React.useState("")
    const [count, setCount] = React.useState(10)
    const [ean, setEan] = React.useState("")

    function onSave(){
        if (loading){
            return;
        }
        setLoading(true)
        if(props.onSave){
            props.onSave(product, count, ean)
        }
        setLoading(false)
        setCount(10)
        setEan("")
        setProduct("")

        if(props.onHide){
            props.onHide()
        }
    }

    function onClear(){
        if(loading){
            return;
        }
        setLoading(true)
        if (props.onClear()){
            props.onClear()
        }
        setLoading(false)
        setCount(10)
        setEan("ean13")
        setProduct("")

        if(props.onHide){
            props.onHide()
        }
    }

    function onChangeEan(e) {
        setEan(e.target.value)
    }

    function onChangeCount(e) {
        setCount(e.target.value)
    }
    return(
        <Modal
        title="Filtrar códigos de barras"
        show={props.show}
        onHide={() => {
            if(props.onHide){
                props.onHide()
            }
            }
        }
        >
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-sm-12">
                        <Text color="primary">Produto associado</Text>
                        <AutoComplete
                            disabled={loading}
                            request={(...args) => searchProducts(...args).then(result => {
                            return result.map(item => ({
                                  ...item,
                                  'sellable.name': item.sellable.name
                                }));
                              })}
                            searchField='sellable.name'
                            labelField='sellable.name'
                            valueField='id'
                            onSelect={e => setProduct(e.value)}
                        />
                    </div>

                    <div className="col-lg-6 col-sm-12">
                            <Text color="primary">Tipo de código de barras</Text>
                            <LoadingInput onChange={onChangeEan} disabled={loading} name="code_type" as="select" defaultValue={""}>
                            <option
                            value={""}>
                                Sem filtro
                            </option>
                            {["ean8", "ean13", "ean14"].map((value, _) => <option selected={value === ean} key={`select_count_${_}`}
                                value={value} >{value}
                                </option>)}
                            </LoadingInput>
                    </div>

                    <div className="col-lg-6 col-sm-12">
                            <Text color="primary">Quantidade a ser exibida</Text>
                            <LoadingInput onChange={onChangeCount} disabled={loading} name="code_type" as="select">
                            {[10, 20, 30, 50, 100, 200, 300, 500, 1000].map((value, _) =>
                                <option selected={value === count} key={`select_count_${_}`}
                                    value={value}>{value}
                                </option>)}
                            </LoadingInput>
                    </div>

                </div>
                <div className="d-flex justify-content-between">
                    <Button disabled={loading} onClick={() => onSave()}>Filtrar</Button>
                    <Button disabled={loading} onClick={() => onClear()}>Limpar filtros</Button>
                </div>
            </div>

        </Modal>
    )
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Barcodes/createFilterModal.jsx